import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';

const LogoWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    textDecoration: 'none',
  },
}));

const LogoCircle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 45,
  height: 45,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  color: '#fff',
  fontWeight: 700,
  fontSize: '1.5rem',
  marginRight: theme.spacing(2.5), // Увеличено расстояние между иконкой и текстом
  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)',
  }
}));

const LogoText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  letterSpacing: 0.5,
  color: theme.palette.primary.main,
  textShadow: '0px 1px 1px rgba(0, 0, 0, 0.05)',
}));

const Logo = ({ variant = 'default', sx = {} }) => {
  const theme = useTheme();
  const isSmall = variant === 'small';
  const [logoExists, setLogoExists] = useState(true);
  const [logoUrl, setLogoUrl] = useState('');
  
  useEffect(() => {
    // Fetch logo URL from settings
    const fetchLogoUrl = async () => {
      try {
        const response = await fetch('/api/settings/logo');
        const data = await response.json();
        if (data && data.success && data.data) {
          setLogoUrl(data.data); // Убираем временную метку
          setLogoExists(true);
        } else {
          setLogoExists(false);
        }
      } catch (error) {
        console.error('Error fetching logo:', error);
        setLogoExists(false);
      }
    };
    
    fetchLogoUrl();
    
    const handleLogoUpdate = (event) => {
      if (event.detail && event.detail.logo) {
        setLogoUrl(event.detail.logo); // Убираем временную метку
        setLogoExists(true);
      } else {
        fetchLogoUrl();
      }
    };
    
    window.addEventListener('logoUpdated', handleLogoUpdate);
    
    return () => {
      window.removeEventListener('logoUpdated', handleLogoUpdate);
    };
  }, []);
  
  if (logoExists) {
    return (
      <LogoWrapper
        component={RouterLink}
        to="/"
        sx={{
          ...sx,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: 0.5,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            height: isSmall ? 40 : 45,
            width: isSmall ? 40 : 45,
            marginRight: theme.spacing(2), // Увеличено расстояние между иконкой и текстом
          }}
        >
          <Box
            component="img"
            src={logoUrl}
            alt="DomikTyumen Logo"
            sx={{
              height: isSmall ? 30 : 35,
              width: isSmall ? 30 : 35,
              objectFit: 'contain',
            }}
          />
        </Box>
        <Box>
          <LogoText
            variant={isSmall ? 'h6' : 'h5'}
            component="span"
          >
            DomikTyumen
          </LogoText>
          {!isSmall && (
            <Typography 
              variant="caption" 
              component="div" 
              sx={{ 
                color: theme.palette.text.secondary, 
                fontWeight: 500, 
                marginTop: -0.5,
                fontSize: '0.75rem'
              }}
            >
              Аренда недвижимости
            </Typography>
          )}
        </Box>
      </LogoWrapper>
    );
  }
  
  return (
    <LogoWrapper
      component={RouterLink}
      to="/"
      sx={{
        ...sx,
      }}
    >
      <LogoCircle sx={{ 
        width: isSmall ? 40 : 45, 
        height: isSmall ? 40 : 45,
        fontSize: isSmall ? '1.2rem' : '1.5rem'
      }}>
        D
      </LogoCircle>
      <Box>
        <LogoText
          variant={isSmall ? 'h6' : 'h5'}
          component="span"
        >
          DomikTyumen
        </LogoText>
        {!isSmall && (
          <Typography 
            variant="caption" 
            component="div" 
            sx={{ 
              color: theme.palette.text.secondary,
              fontWeight: 500,
              marginTop: -0.5,
              fontSize: '0.75rem'
            }}
          >
            Аренда недвижимости
          </Typography>
        )}
      </Box>
    </LogoWrapper>
  );
};

export default Logo;
